import { ROLES } from '@/constants/roles';
import formatRoutes from '@/helpers/user-redesign/formatRoutes';
// TEMP_DUPLICATE_MERGE_PREVIEW: the lazy test route is excluded from production.
import { isDuplicateMergePreviewEnabled } from '@/modules/UserDuplicatesMerges/services/duplicateMergePreviewContext';

export const resultRoute = {
  path: '/redesign/my-history',
  name: 'my-history',
  component: () => import('@/modules/UserProfile/views/my-history.vue'),
  meta: {
    title: 'Результаты',
    accessList: [ROLES.member, ROLES.certificate],
    navigation: {
      back: false,
    },
  },
};

const routes = [
  {
    path: '/redesign/my-profile',
    name: 'my-profile',
    component: () => import('@/modules/UserProfile/views/my-profile.vue'),
    meta: {
      title: 'Мой профиль',
    },
  },
  {
    path: '/my-profile-duplicates',
    name: 'my-profile-duplicates',
    component: () => import('@/modules/UserProfile/views/my-profile-duplicates.vue'),
    meta: {
      title: 'Похожие аккаунты',
      accessList: [ROLES.certificate, ROLES.member],
    },
  },
  {
    path: '/redesign/my-portfolio',
    name: 'my-portfolio',
    component: () => import('@/modules/UserProfile/views/my-portfolio.vue'),
    meta: {
      title: 'Портфолио',
    },
  },
  {
    path: '/redesign/my-notifications',
    name: 'my-notifications',
    component: () => import('@/modules/UserProfile/views/my-notifications.vue'),
    meta: {
      title: 'Уведомления',
    },
  },
  resultRoute,
  {
    path: '/redesign/instructions',
    name: 'my-instructions',
    component: () => import('@/modules/UserProfile/views/instructions.vue'),
    meta: {
      title: 'Инструкции',
    },
  },
];

export default [
  ...process.env.NODE_ENV === 'development' ? [{
    path: '/dev/duplicate-merge-preview',
    name: 'duplicate-merge-preview',
    component: () => import('@/modules/UserDuplicatesMerges/views/duplicate-merge-preview.vue'),
    beforeEnter: (to, from, next) => next(isDuplicateMergePreviewEnabled() ? undefined : { name: 'main' }),
    meta: { title: 'ТЕСТ — объединение профилей', layout: 'ui-design', accessList: Object.values(ROLES) },
  }] : [],
  ...formatRoutes(routes, { layout: 'ui-design' }),
  {
    path: '/ui-my-profile',
    name: 'ui-my-profile',
    component: () => import('@/modules/UserProfile/views/my-profile.vue'),
    meta: {
      title: 'Мой профиль',
      layout: 'ui-design',
    },
  },
];
